import axios from "axios";
import React, { createContext, useContext, useState } from "react";
const StateContext = createContext();

export const ContextProvider = ({ children }) => {
  const [user, setUser] = useState("");
  const [isScrolled, setIsScrolled] = useState(false);
  const [sidebarOpened, setSidebarOpened] = useState(false);
  const [categories, setCategories] = useState([]);
  const [singleCategoryDetails, setSingleCategoryDetails] = useState([]);
  const [itemDetail, setItemDetail] = useState({});
  const [cartItem, setCartItem] = useState([]);
  const [sumOfQuantity, setSumOfQuantity] = useState();
  const [itemRating, setItemRating] = useState(5);
  const [sidebarCartDetail, setSidebarCartDetail] = useState(false);
  const [deletedFromLocalStorage, setDeletedFromLocalStorage] = useState(false);
  const [select, setSelect] = useState();
  const [total, setTotal] = useState("");
  const [alert, setAlert] = useState(false);
  const [showSearch, setShowSearch] = useState(false);
  const [timeRemaining, setTimeRemaining] = useState(10);
  const [allOrders, setAllOrders] = useState();
  const [address, setAddress] = useState();
  const [userName, setUserName] = useState();
  const [products, setProducts] = useState();

  const CategoriesApiCall = async () => {
    await axios
      .get("https://matrix-api-h2bb.onrender.com/")
      .then((response) => {
        setCategories(response.data);
      });
  };

  const allProducts = () => {
    axios
      .get(`https://matrix-api-h2bb.onrender.com/products`)
      .then((res) => setProducts(res.data));
  };

  const singleCategory = (id) => {
    axios
      .get(`https://matrix-api-h2bb.onrender.com/products/${id}`)
      .then((res) => setSingleCategoryDetails(res.data));
  };

  const searchPageDetails = (id) => {
    axios
      .get(`https://matrix-api-h2bb.onrender.com/searchResultItem/${id}`)
      .then((res) => setSingleCategoryDetails(res.data));
  };

  const AddUser = async (email, password, username) => {
    await axios
      .post("https://matrix-api-h2bb.onrender.com/user", {
        customer_username: username,
        customer_email: email,
      })
      .then((response) => {
        console.log(response.data);
      });
  };

  const getUserNameDetails = (id) => {
    if (user) {
      axios
        .get(`https://matrix-api-h2bb.onrender.com/customers/${id}`)
        .then((res) => setUserName(res.data[0].customer_username));
    }
  };

  const getOrderAddress = (id) => {
    axios
      .get(`https://matrix-api-h2bb.onrender.com/address/${id}`)
      .then((res) => setAddress(res.data));
  };

  const getAllOrders = (id) => {
    axios
      .get(`https://matrix-api-h2bb.onrender.com/allOrders/${id}`)
      .then((res) => setAllOrders(res.data));
  };

  const getCartFromLocalStorage = () => {
    let cart = JSON.parse(localStorage.getItem("cartitems"));
    if (cartItem) {
      setCartItem(cart);
    } else {
      setCartItem([]);
    }
  };

  const handleDelete = (productId) => {
    let temp = cartItem.filter((items) => items.prod_id !== productId);
    localStorage.setItem("cartitems", JSON.stringify(temp));
    setCartItem(temp);
    setSelect(cartItem.quantity);
    setDeletedFromLocalStorage(
      cartItem.filter((items) => items.prod_id == productId)
    );
    setAlert(true);

    getTotalOnDelete(temp);
    setTimeRemaining(10);
    window.scrollTo(0, 0);
  };

  const getTotalOnDelete = (recalculate) => {
    let temp = recalculate.map((item) => {
      return parseFloat(item.price) * parseInt(item.quantity);
    });
    let sum = temp.reduce((prev, next) => {
      return prev + next;
    }, 0);
    setTotal(sum);
  };

  const getTotal = () => {
    if (cartItem) {
      let temp = cartItem.map((item) => {
        return parseFloat(item.price) * parseInt(item.quantity);
      });
      let qty = cartItem.map((item) => {
        return parseInt(item.quantity);
      });
      let sum = temp.reduce((prev, next) => {
        return prev + next;
      }, 0);
      let sumofqty = qty.reduce((prev, next) => {
        return prev + next;
      }, 0);
      setSumOfQuantity(sumofqty);
      setTotal(sum);
    }
  };

  const handleQuantity = (productId, quantity) => {
    for (let product of cartItem) {
      if (product.prod_id === productId) {
        product.quantity = quantity;
      }
    }
    localStorage.setItem("cartitems", JSON.stringify(cartItem));
    setCartItem(cartItem);
    getTotal();
  };

  return (
    // eslint-disable-next-line react/jsx-no-constructed-context-values
    <StateContext.Provider
      value={{
        isScrolled,
        setIsScrolled,
        categories,
        setCategories,
        singleCategoryDetails,
        setSingleCategoryDetails,
        CategoriesApiCall,
        itemDetail,
        setItemDetail,
        singleCategory,
        cartItem,
        setCartItem,
        sidebarOpened,
        setSidebarOpened,
        total,
        setTotal,
        user,
        setUser,
        AddUser,
        itemRating,
        setItemRating,
        sidebarCartDetail,
        setSidebarCartDetail,
        getCartFromLocalStorage,
        deletedFromLocalStorage,
        setDeletedFromLocalStorage,
        getTotal,
        select,
        setSelect,
        handleDelete,
        handleQuantity,
        alert,
        setAlert,
        timeRemaining,
        setTimeRemaining,
        showSearch,
        setShowSearch,
        searchPageDetails,
        userName,
        setUserName,
        getUserNameDetails,
        address,
        setAddress,
        getOrderAddress,
        allOrders,
        setAllOrders,
        getAllOrders,
        sumOfQuantity,
        setSumOfQuantity,
        products,
        setProducts,
        allProducts,
      }}
    >
      {children}
    </StateContext.Provider>
  );
};

export const useStateContext = () => useContext(StateContext);
